<template>
  <div class="live">
    <div class="title">正在直播</div>
    <div v-if="live.length" class="container">
      <OnLive v-for="online in live" :online="online" :key="online.event_info_id"></OnLive>
    </div>
    <van-empty v-else description="暂无直播"></van-empty>
    <div class="title" style="margin-top:20px">直播预告</div>
    <div class="sub-title">
      <span></span>
      今天
    </div>
    <div v-if="today.length" class="container">
      <OnBoard v-for="item in today" :item="item" :key="item.event_info_id"></OnBoard>
    </div>
    <van-empty description="暂无预告"></van-empty>
    <div class="sub-title">
      <span></span>
      明天
    </div>
    <div v-if="tomorrow.length" class="container">
      <OnBoard v-for="item in tomorrow" :item="item" :key="item.event_info_id"></OnBoard>
    </div>
    <van-empty v-else description="暂无预告"></van-empty>
    <div class="sub-title">
      <span></span>
      更久
    </div>
    <div v-if="other.length" class="container">
      <OnBoard v-for="item in other" :item="item" :key="item.event_info_id"></OnBoard>
    </div>
    <van-empty v-else description="暂无预告"></van-empty>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getOnlineList} from '@/api'
import {getRemainderTime} from '@/ultis'
import OnLive from '@/components/OnLive'
import OnBoard from '@/components/OnBoard'
export default {
  components: {
    OnBoard,
    OnLive
  },
  data() {
    return {
      tomorrow: [],
      today: [],
      other: [],
      live: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getOnlineList().then(res => {
        const {tomorrow, today, other, live} = res.data
        this.tomorrow = tomorrow || []
        this.today = today || []
        this.other = other || []
        this.live = live || []
        this.tomorrow.forEach(item => {
          item.time = getRemainderTime(parseInt(item.event_start_time / 1000))
        })
        this.other.forEach(item => {
          item.time = getRemainderTime(parseInt(item.event_start_time / 1000))
        })
        this.today.forEach(item => {
          item.time = getRemainderTime(parseInt(item.event_start_time / 1000))
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.live {
  padding: 12px 16px;
}
.title {
  color: #303133;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
}

.sub-title {
  position: relative;
  color: #303133;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-weight: 700;
  margin-bottom: 20px;
  span {
    display: inline-block;
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background: #4465f3;
    margin-right: 6px;
  }
}
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
